import { useState } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

const DetailSubtotalSection = ({ order, logisticDetail, rupiahFormat }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const total = order?.subTotalAmountPaid + (logisticDetail?.totalRate || 0);

  const totalItem = order.items
    .map((q) => q.quantity)
    .reduce((a, b) => a + b, 0);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
        <p className="mb-0 text-bold">{isExpanded ? "Total" : "Subtotal"}</p>

        <span className="d-flex align-items-center">
          {rupiahFormat(total)}

          {isExpanded ? (
            <HiChevronUp
              size={20}
              className="pointer"
              onClick={() => setIsExpanded(false)}
            />
          ) : (
            <HiChevronDown
              size={20}
              className="pointer"
              onClick={() => setIsExpanded(true)}
            />
          )}
        </span>
      </div>

      {isExpanded && (
        <div className="weight-light pb-3 border-bottom">
          <p className="d-flex justify-content-between align-items-center mb-1">
            <span>Subtotal ({totalItem} Barang)</span>
            {rupiahFormat(order?.subTotalAmount)}
          </p>

          <p className="d-flex justify-content-between align-items-center mb-1">
            <span>Diskon</span>-{" "}
            {rupiahFormat(order?.subTotalSpecialPricePromo)}
          </p>

          <p className="d-flex justify-content-between align-items-center mb-1">
            <span>Biaya Kirim</span>
            {rupiahFormat(logisticDetail?.subTotalRate || 0)}
          </p>

          <p className="d-flex justify-content-between align-items-center mb-1">
            <span>Diskon Biaya Kirim</span>-{" "}
            {rupiahFormat(logisticDetail?.discountRate || 0)}
          </p>
        </div>
      )}
    </>
  );
};

export default DetailSubtotalSection;
